import { render, staticRenderFns } from "./CurrentOrder.vue?vue&type=template&id=4c1f8748&"
import script from "./CurrentOrder.vue?vue&type=script&lang=js&"
export * from "./CurrentOrder.vue?vue&type=script&lang=js&"
import style0 from "./CurrentOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports